
module.exports = function () {};
